import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-genere",
  templateUrl: "./genere.component.html",
  styleUrls: ["./genere.component.css"],
})
export class GenereComponent implements OnInit {
  constructor(
    private pagesService: BaseService,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) {}
  subcategory = [];
  apiParam = { slug: "", limit: 10, offset: 0 };
  shimarStatus = true;
  loadMore: boolean;
  genereData = {};
  noRecordStatus = true;
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
      }
      this.getData();
    });
  }

  getData() {
    this.loadMore = true;
    this.pagesService.getDataByGenere(this.apiParam).subscribe((data: any) => {
      this.genereData = data.results;
      this.subcategory = this.subcategory.concat(data.results.subcategory);
      this.subcategory.forEach((element) => {
        if (element.content.length > 0 && this.noRecordStatus === true) {
          this.noRecordStatus = false;
        }
      });
      this.shimarStatus = false;
      this.loadMore = false;
    });
  }

  onScroll() {
    if (this.subcategory.length > 0) {
      this.apiParam.offset = this.apiParam.offset + this.apiParam.limit;
      this.getData();
      this.loadMore = false;
    }
  }
}
